import type { MediaPlan } from '@mint-sdk/api-media-plan';

export const getDefaultExpand = (hierarchy: MediaPlan.SidebarItem[]) => {
  return hierarchy.reduce(
    (acc, item) => {
      if (!item.subItems?.length) {
        return acc;
      }

      Object.assign(acc, getDefaultExpand(item.subItems));
      acc[item.mediaDataId] = true;

      return acc;
    },
    {} as Record<string, boolean>,
  );
};

export const normalizeText = (text: string) => text.trim().toLowerCase();

export const filterTreeItems = (
  query: string,
  items: MediaPlan.SidebarItem[],
) => {
  return items.reduce((acc, item) => {
    const matchesQuery = normalizeText(item.name).includes(
      normalizeText(query),
    );

    if (matchesQuery) {
      acc.push(item);
      return acc;
    }

    if (!item.subItems.length) {
      return acc;
    }

    const filteredSubItems = filterTreeItems(query, item.subItems);

    if (filteredSubItems.length > 0) {
      acc.push({ ...item, subItems: filteredSubItems });
    }

    return acc;
  }, [] as MediaPlan.SidebarItem[]);
};
